// extracted by mini-css-extract-plugin
export var link = "_qy-0";